import React from 'react'
import { toMoney } from '@mobi/utils/money'
import { Icon } from '@mobi/component-library/Common/Icon'
import { BetCard } from '@mobi/betslip/Components/Common/BetCard'
import type { BetLoopKambiShareCoupon } from '@core/Areas/BetLoop/types'
import { BetCardTitle } from '@mobi/betslip/Components/Common/BetCardTitle'
import { formatKambiCurrencyToDollarDecimal } from '@core/Areas/KambiSports/helpers/currencyFormat'
import { getEventLink } from '@core/Areas/KambiSports/helpers/navigation'
import { CountdownStatus } from '../Common/CountdownStatus'

export const SameGameMulti: React.FC<{
  legCount: number
  event: BetLoopKambiShareCoupon['events'][0]
  outcomes: BetLoopKambiShareCoupon['outcomes']
  betOffers: BetLoopKambiShareCoupon['betOffers']
  playedOdds: BetLoopKambiShareCoupon['couponRows'][0]['playedOdds']
  betStaus:
    | BetLoopKambiShareCoupon['bets'][0]['betStatus']
    | BetLoopKambiShareCoupon['couponRows'][0]['status']
}> = ({ legCount, event, outcomes, betOffers, playedOdds, betStaus }) => {
  const titleText = `${legCount} Leg Same Game Multi`
  const odds = playedOdds && toMoney(formatKambiCurrencyToDollarDecimal(playedOdds))

  return (
    <>
      <BetCardTitle title={titleText} rightComponent={odds} />

      <BetCard.EventDetails
        iconComponent={<Icon size='1.6rem' type='tab' />}
        heading={event.eventName}
        statusComponent={
          <CountdownStatus eventStartTimes={event.eventStartDate} betStatus={betStaus} />
        }
      />

      {outcomes.map(outcome => {
        return (
          <BetCard.SelectionInfo
            key={outcome.betOfferId}
            iconComponent={<Icon size='1.6rem' type='tab' />}
            heading={outcome.label}
            subHeading={betOffers.find(b => b.betOfferId === outcome.betOfferId)?.criterion}
            linkInfo={{
              pathname: getEventLink(event.eventId),
            }}
          />
        )
      })}
    </>
  )
}
